import { render, staticRenderFns } from "./ThirdParties.vue?vue&type=template&id=661c1432&scoped=true&"
import script from "./ThirdParties.vue?vue&type=script&lang=js&"
export * from "./ThirdParties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c1432",
  null
  
)

export default component.exports